export var SUGGEST_ITEM_HEIGHT = 44;
export var MOBILE_HEADER_HEIGHT = 136;
export var MOBILE_HEADER_POPOVER_HEIGHT = 112;
export var IOS_KEYBOARD_HEIGHT = 270;
export var themes = ['b2c', 'b2b'];
export var sizes = ['medium', 'small'];